<template>
	<div class="security-page">
		<div class="member-card">
			<div class="card-header">
				<div>
					<div class="card-title">账号安全</div>
					<div class="card-desc">管理账号的绑定信息，保障账号安全</div>
				</div>
			</div>

			<div class="security-grid">
				<!-- 手机号 -->
				<!-- <div class="security-item">
					<div class="security-item-icon" :class="uinfo.consumerPhone ? 'icon-success' : 'icon-warning'">
						<i class="el-icon-mobile-phone"></i>
					</div>
					<div class="security-item-content">
						<div class="security-item-title">手机号码</div>
						<div class="security-item-info">{{ uinfo.consumerPhone || '未绑定' }}</div>
					</div>
					<el-button size="small" @click="handleMobile">
						{{ uinfo.consumerPhone ? '修改手机号' : '绑定手机号' }}
					</el-button>
				</div> -->

				<!-- 微信 -->
				<div class="security-item">
					<div class="security-item-icon" :class="uinfo.bindWechat ? 'icon-success' : 'icon-warning'">
						<i class="el-icon-chat-dot-round"></i>
					</div>
					<div class="security-item-content">
						<div class="security-item-title">微信绑定</div>
						<div class="security-item-info">{{ uinfo.bindWechat ? '已绑定微信' : '未绑定微信' }}</div>
					</div>
					<el-button v-if="!uinfo.bindWechat" size="small" @click="handleWechat">绑定微信</el-button>
					<el-tag v-else size="small" type="success" effect="plain" style="margin-left: auto">已绑定</el-tag>
				</div>

				<!-- 邮箱 -->
				<!-- <div class="security-item">
					<div class="security-item-icon" :class="uinfo.consumerEmail ? 'icon-success' : 'icon-warning'">
						<i class="el-icon-message"></i>
					</div>
					<div class="security-item-content">
						<div class="security-item-title">邮箱地址</div>
						<div class="security-item-info">{{ uinfo.consumerEmail || '未绑定' }}</div>
					</div>
					<el-button size="small" @click="handleMail">
						{{ uinfo.consumerEmail ? '修改邮箱' : '绑定邮箱' }}
					</el-button>
				</div> -->

				<!-- 密码 -->
				<div class="security-item">
					<div class="security-item-icon" :class="uinfo.consumerPwd ? 'icon-success' : 'icon-warning'">
						<i class="el-icon-lock"></i>
					</div>
					<div class="security-item-content">
						<div class="security-item-title">登录密码</div>
						<div class="security-item-info">{{ uinfo.consumerPwd ? '密码可搭配手机号登录使用' : '未设置密码' }}</div>
					</div>
					<el-button size="small" @click="handlePwd">
						{{ uinfo.consumerPwd ? '修改密码' : '设置密码' }}
					</el-button>
				</div>
			</div>
		</div>

		<!-- 验证旧手机号码 -->
		<VerifyOldPhone ref="VerifyOldPhoneRef" @nextInfo="handleNext"></VerifyOldPhone>
		<!-- 绑定新手机号码 -->
		<EditNewPhone ref="EditNewPhoneRef" @confirmInfo="handleConfirmPhone" />
		<!-- 修改邮箱号 -->
		<DialogEditMail ref="DialogEditMailRef" @confirmInfo="handleConfirmMail" />
		<!-- 绑定微信号 -->
		<DialogWechat ref="DialogWechatRef" @confirmInfo="handleConfirmWechat" @mergeAccount="handleMergeAccount" />
		<!-- 修改密码 -->
		<DialogEditPwd ref="DialogEditPwdRef" :isHasPwd="uinfo.consumerPwd ? true : false" @confirmInfo="handleConfirmPwd" />
		<!-- 合并账户 -->
		<DialogMergeAccount ref="DialogMergeAccountRef" @confirmInfo="handleConfirmMergeAccount" />
	</div>
</template>

<script>
import Y from '@/utils/Y';
import { mapGetters, mapActions } from 'vuex';
import DialogEditPhone from '@/views/UserCenter/components/DialogEditPhone.vue';
import DialogEditMail from '@/views/UserCenter/components/DialogEditMail.vue';
import VerifyOldPhone from '@/views/UserCenter/components/VerifyOldPhone.vue';
import EditNewPhone from '@/views/UserCenter/components/EditNewPhone.vue';
import DialogWechat from '@/views/UserCenter/components/DialogEditWechat.vue';
import DialogEditPwd from '@/views/UserCenter/components/DialogEditPwd.vue';
import DialogMergeAccount from '@/views/UserCenter/components/DialogMergeAccount.vue';
import { postMemberDeactivate } from '@/api/user/user.js';

export default {
	components: {
		DialogEditPhone,
		DialogEditMail,
		VerifyOldPhone,
		EditNewPhone,
		DialogWechat,
		DialogEditPwd,
		DialogMergeAccount
	},
	computed: {
		...mapGetters('User', ['uinfo'])
	},
	mounted() {},
	methods: {
		...mapActions('Settings', ['setWechatBindShow']),
		...mapActions('User', ['logout']),

		// 注销账户
		handleDeactivate() {
			this.$confirm('注销账户后所有数据将被清空，且无法恢复。确定要注销吗？', '注销确认', {
				confirmButtonText: '确定注销',
				cancelButtonText: '取消',
				type: 'warning',
				center: true
			})
				.then(() => {
					this.doDeactivate();
				})
				.catch(() => {});
		},

		doDeactivate() {
			postMemberDeactivate()
				.then(res => {
					if (res.code == 200) {
						this.$message.success('账户注销成功');
						this.logout();
					} else {
						this.$message.error(res.msg || '账户注销失败');
					}
				})
				.catch(() => {
					this.$message.error('网络错误，请稍后重试');
				});
		},

		// 合并账户
		handleMergeAccount() {
			this.$refs.DialogMergeAccountRef.dialogVisible = true;
		},
		handleConfirmMergeAccount() {
			Y.msg.success('账户合并成功');
			this.$refs.DialogMergeAccountRef.dialogVisible = false;
			this.$store.dispatch('User/getUserInfo');
		},

		// 密码
		handlePwd() {
			this.$refs.DialogEditPwdRef.dialogVisible = true;
		},
		handleConfirmPwd() {
			Y.msg.success('密码修改成功');
			this.$refs.DialogEditPwdRef.dialogVisible = false;
			this.$store.dispatch('User/getUserInfo');
		},

		// 手机号
		handleMobile() {
			if (this.uinfo.consumerPhone) {
				this.$refs.VerifyOldPhoneRef.dialogVisible = true;
			} else {
				this.$refs.EditNewPhoneRef.dialogVisible = true;
			}
		},
		handleNext() {	
			this.$refs.VerifyOldPhoneRef.dialogVisible = false;
			this.$refs.EditNewPhoneRef.dialogVisible = true;
		},
		handleConfirmPhone() {
			Y.msg.success('手机号码绑定成功');
			this.$refs.EditNewPhoneRef.dialogVisible = false;
			this.$store.dispatch('User/getUserInfo');
		},

		// 邮箱
		handleMail() {
			this.$refs.DialogEditMailRef.dialogVisible = true;
		},
		handleConfirmMail() {
			Y.msg.success('邮箱绑定成功');
			this.$refs.DialogEditMailRef.dialogVisible = false;
			this.$store.dispatch('User/getUserInfo');
		},

		// 微信
		handleWechat() {
			this.setWechatBindShow(true);
		},
		handleConfirmWechat() {
			Y.msg.success('微信号绑定成功');
			this.$refs.DialogWechatRef.dialogVisible = false;
			this.$store.dispatch('User/getUserInfo');
		}
	}
};
</script>

<style lang="less" scoped>
.security-page {
	padding: 0;
	margin-left: 20px;
}

	/* ========== 外层卡片 ========== */
	.member-card {
		background: #fff;
		border-radius: 12px;
		border: 1px solid #e2e8f0;
		padding: 28px 32px;
		margin-bottom: 16px;
		box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
	}

	/* ========== 卡片头 ========== */
	.card-header {
		display: flex;
		align-items: flex-start;
		justify-content: space-between;
		margin-bottom: 24px;
		padding-bottom: 20px;
		border-bottom: 1px dashed #e2e8f0;
	}

	.card-title {
		font-size: 18px;
		font-weight: 700;
		color: #0f172a;
		margin-bottom: 4px;
	}

	.card-desc {
		font-size: 13px;
		color: #94a3b8;
		line-height: 1.6;
	}

	/* ========== 安全项网格 ========== */
	.security-grid {
		display: grid;
		grid-template-columns: repeat(2, 1fr);
		gap: 16px;
	}

	/* ========== 单个安全项 ========== */
	.security-item {
		display: flex;
		align-items: center;
		gap: 14px;
		padding: 18px 20px;
		border: 1px solid #e2e8f0;
		border-radius: 10px;
		background: #f8fafc;
		transition: border-color 0.2s, box-shadow 0.2s;

		&:hover {
			border-color: #cbd5e1;
			box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
		}
	}

	/* ========== 图标 ========== */
	.security-item-icon {
		width: 42px;
		height: 42px;
		border-radius: 10px;
		display: flex;
		align-items: center;
		justify-content: center;
		flex-shrink: 0;

		i {
			font-size: 20px;
		}

		&.icon-success {
			background: #dcfce7;
			i { color: #16a34a; }
		}

		&.icon-warning {
			background: #fef3c7;
			i { color: #d97706; }
		}
	}

	/* ========== 内容 ========== */
	.security-item-content {
		flex: 1;
		min-width: 0;
	}

	.security-item-title {
		font-size: 14px;
		font-weight: 600;
		color: #0f172a;
		margin-bottom: 4px;
	}

	.security-item-info {
		font-size: 12px;
		color: #94a3b8;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}

/* ========== 媒体查询 ========== */
@media screen and (min-device-width: 768px) and (max-device-width: 1023px) {
	.security-grid {
		grid-template-columns: 1fr;
	}
}

@media screen and (min-device-width: 1024px) and (max-device-width: 1366px) {
	.security-grid {
		grid-template-columns: repeat(2, 1fr);
	}
}
</style>
